module.exports = __webpack_public_path__ + "media/images/dashboard/wedding_styles/boho1-18622d7d94d0965f8af2cea74d2bda71.jpg";